import React, { useEffect, useState } from "react";
import { fetch } from "../utils/api";

import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Member } from "../components/Member";
import { CtaList } from "../components/CtaList";
import { Link } from "react-router-dom";

import "../assets/styles/consultant.scss";

export const Consultant = () => {
  const [members, setMembers] = useState();

  useEffect(() => {
    (async () => {
      const members = await fetch({ category: "member" });
      setMembers(members.data);
    })();
  }, []);

  const memberProps = (member: any) => {
    return {
      name: member.acf.name_jp as string,
      name_en: member.acf.name_en as string,
      position: member.acf.position as string,
      certification: member.acf.certification as string,
      career: member.acf.career as string,
      thumbnail: member._embedded["wp:featuredmedia"][0].source_url as string,
    };
  };

  return (
    <div className="consultant">
      <Header>
        <div className="kv">
          <img
            src="../images/consultant/kv.jpg"
            className="pc"
            style={{ pointerEvents: "none" }}
          />
          <img
            src="../images/consultant/kv-sp.jpg"
            className="sp"
            style={{ pointerEvents: "none" }}
          />
        </div>
      </Header>
      <section className="consultant-main">
        <ul>
          {members &&
            Array.from(members)
              .reverse()
              .map((member: any, index: number) => {
                return (
                  <li
                    key={index}
                    className={(index + 1) % 2 === 0 ? "revers" : ""}
                  >
                    <Member member={memberProps(member)} />
                  </li>
                );
              })}
        </ul>
      </section>
      <section className="cta">
        <div className="inner">
          {/* <Link to="" className="adoption-bnr">
            <img src="../images/adoption-bnr.png" alt="" className="pc-bnr" />
            <img
              src="../images/adoption-bnr_sp.png"
              alt=""
              className="sp-bnr"
            />
          </Link> */}
          <CtaList />
        </div>
      </section>
      <Footer />
    </div>
  );
};
